<script>
    import { onMount } from "svelte";
    import { v4 } from "uuid";

    export let id = "";
    export let containerClass = "";
    export let contentClass = "";
    export let contentStyle = "";
    export let tooltipPosition = ""; // top, bottom, left, right combinations
    export let zIndex = Number(0);
    export let hoverTriggerFunc = () => {};
    export let hideTimeOutMs = Number(200);
    export let alwaysOpen = false;

    let visible = false;
    let position = { top: 0, left: 0 };
    let tooltipTriggerElement;
    let hideTimeout;

    const uuid = v4();

    onMount(() => {
        if(alwaysOpen) showTooltip();
    })

    const hoverTrigger = async () => {
        await hoverTriggerFunc();
        showTooltip();
        requestAnimationFrame(updatePosition);
    };

    const showTooltip = () => {
        clearInterval(hideTimeout);
        visible = true;
        requestAnimationFrame(updatePosition);
    };

    const hideTooltip = () => {

        hideTimeout = setTimeout(() => {
            visible = false;
            position = { top: 0, left: 0 };
        }, hideTimeOutMs);
    };

    const updatePosition = () => {
        const targetRect = tooltipTriggerElement.getBoundingClientRect();
        const tooltipContainer = document.getElementById(id ? id : uuid);

        if (!tooltipContainer) return;

        const tooltipRect = tooltipContainer.getBoundingClientRect();

        let top = targetRect.height + window.scrollY + 5;
        let left = window.scrollX;

        if (tooltipPosition.includes("left")) left = -tooltipRect.width;
        else if (tooltipPosition.includes("right")) left = tooltipRect.width;
        else if (targetRect.left + tooltipRect.width > window.innerWidth)
            left = window.scrollX - tooltipRect.width;

        if (tooltipPosition.includes("top")) top = -tooltipRect.height;
        else if (tooltipPosition.includes("bottom")) top = tooltipRect.height;
        else if (targetRect.bottom + tooltipRect.height > window.innerHeight)
            top = window.scrollY - tooltipRect.height - 5;

        position = { top, left };
    };
</script>

<div
    class={`relative inline-block align-middle z-[${zIndex}] ${containerClass}`}
>
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        bind:this={tooltipTriggerElement}
        on:mouseenter={hoverTrigger}
        on:mouseleave={hideTooltip}
        class="cursor-help"
    >
        <slot name="tooltipTrigger" />
    </div>

    {#if visible}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            id={id ? id : uuid}
            class="absolute p-2 bg-zinc-100 text-black border border-secondary rounded-lg z-[99999] inline-block min-w-[100px] max-w-[500px] w-max {contentClass}"
            style="top: {position.top}px; left: {position.left}px; {contentStyle}"
            on:mouseenter={showTooltip}
            on:mouseleave={hideTooltip}
        >
            <slot />
        </div>
    {/if}
</div>
